/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

document.addEventListener('DOMContentLoaded', () => {

  // header
  setTimeout(() => {
    const $navbar = $('.j-navbar-menu');
    const doc = document.documentElement;
    let prevScroll = window.scrollY || doc.scrollTop;
    let curScroll;
    let delta = 0;
    let prevDelta = 0;

    window.addEventListener('scroll', () => {
      curScroll = window.scrollY || doc.scrollTop;

      if (curScroll > prevScroll && window.scrollY > 100) {
        // scrolled down
        delta = 1;
      } else if (curScroll < prevScroll) {
        // scrolled up
        delta = -1;
      }

      if (delta !== prevDelta) {
        if (delta < 0) {
          $navbar.removeClass('h-hide');
        } else {
          $navbar.addClass('h-hide');
        }
      }

      prevScroll = curScroll;
    });
  }, 1000);

  // footer 開關權益全文
  const openRisk = document.getElementById('j-open-risk');
  const closeRisk = document.getElementById('j-close-risk');
  const riskContent = document.getElementById('j-risk-content');
  openRisk.addEventListener('click', function () {
    openRisk.classList.add('visually-hidden');
    riskContent.classList.remove('visually-hidden');
    closeRisk.classList.remove('visually-hidden');
  });
  closeRisk.addEventListener('click', function () {
    closeRisk.classList.add('visually-hidden');
    riskContent.classList.add('visually-hidden');
    openRisk.classList.remove('visually-hidden');
  });

  // close mobile header toggler
  const mobileToggler = document.querySelector('.j-header-toggler');
  const mobileOffcanvas = document.querySelector('.offcanvas-top');

  mobileOffcanvas.addEventListener('show.bs.offcanvas', event => {
    mobileToggler.classList.remove('navbar-toggler-icon');
    mobileToggler.classList.add('btn', 'btn-close');
  });

  mobileOffcanvas.addEventListener('hidden.bs.offcanvas', event => {
    mobileToggler.classList.remove('btn', 'btn-close');
    mobileToggler.classList.add('navbar-toggler-icon');
  });
});
